import React, { Component } from 'react';
import GeneralContractorForm from 'components/admin/general-contractors/GeneralContractorForm';
import { connect } from 'react-redux';
import { updateGeneralContractorTeam } from 'components/admin/general-contractors/store/actions';
import { getCurrentGeneralContractor } from 'components/admin/general-contractors/store/selectors';

class GeneralContractorTeamEdit extends Component {
  handleOnSubmit = (values) => {
    this.props.dispatch(updateGeneralContractorTeam(values, true));
  };

  render() {
    let generalContractor = this.props.generalContractor;
    if (generalContractor) {
      this.initialValues = {
        id: generalContractor.id,
        name: generalContractor.name,
        licenceNumber: generalContractor.license_number,
        firstName: generalContractor.contact.first_name,
        lastName: generalContractor.contact.last_name,
        email: generalContractor.contact.email,
        phoneNumber: generalContractor.contact.phone_number,
        companyLogo: generalContractor.logo,
      };
      if (generalContractor.location) {
        this.initialValues['streetAddress'] =
          generalContractor.location.street_address_1;
        this.initialValues['unitNumber'] =
          generalContractor.location.street_address_2;
        this.initialValues['city'] = generalContractor.location.city;
        this.initialValues['state'] = generalContractor.location.state;
        this.initialValues['zipCode'] = generalContractor.location.zip;
      }
    }

    return (
      <GeneralContractorForm
        initialValues={this.initialValues}
        onSubmit={this.handleOnSubmit}
      />
    );
  }
}
export default connect((state) => {
  return {
    generalContractor: getCurrentGeneralContractor(state),
  };
})(GeneralContractorTeamEdit);



// WEBPACK FOOTER //
// ./src/components/admin/team/GeneralContractorTeamEdit.js